import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import FieldWrapper from '@shared/components/forms/inputs/field-wrapper/field-wrapper.vue';
import AbstractField from '@shared/components/forms/inputs/abstract-field/abstract-field';
import 'vue-select/dist/vue-select.css';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import BpcDrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import BcRejectDirectDebitFileItemModal from '@accounting/components/modals/reject-direct-debit-file-item-modal/reject-direct-debit-file-item-modal.vue';

@Component({
  name: 'bpc-direct-debit-file-table-input',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-field-wrapper': FieldWrapper,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-drawer-modal': BpcDrawerModal,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bc-reject-direct-debit-file-item-modal': BcRejectDirectDebitFileItemModal,
  },
})
export default class DirectDebitFileTableInput extends mixins(AbstractField, AbstractTable) {
  @Prop(Array) readonly value: any[];

  @Prop(String) readonly selectEntity: string;
  @Prop(String) readonly selectPluralEntity: string;

  @Prop({ type: String, default: 'drawer' }) readonly type: string;

  @Prop(Array) readonly filters: any[];
  @Prop(String) readonly fieldForStorage: string;

  @Prop(Boolean) readonly withDraft: boolean;

  //@Prop(String) readonly formConfigName: string;

  @Prop({
    type: Array,
    default: () => ['configLoaded', 'paginationLoaded', 'orderLoaded'],
  })
  readonly customFlagsToCheckBeforeLoadEntities: Array<any>;

  public entity: any = null;
  public entityName = this.selectEntity;
  public pluralEntityName = this.selectPluralEntity;
  public isProcessing = false;
  public showRejectDirectDebitFileItemModal = false;
  public bulkReject: boolean = false;
  public elementsToRejectIds: number[] = [];
  public elementToRejectId: number = 0;

  public customRowActions = {
    confirm: {
      activated: false,
      type: 'action',
      icon: 'check',
      show: false,
      event: 'mark-as-confirmed',
      text: 'confirm',
      permissions: [],
    },
    reject: {
      activated: false,
      type: 'action',
      icon: 'ban',
      show: false,
      event: 'mark-as-rejected',
      text: 'reject',
      permissions: [],
    },
  };

  get showedFields() {
    const showedFields = [];
    for (const field of this.$refs.provider.fields) {
      if (!field['conditionalShow']) {
        showedFields.push(field);
      } else {
        const keys = field['conditionalShow']['fieldPath'].split('.');
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let conditionalValue = this;
        for (const key of keys) {
          if (conditionalValue[key] != 'undefined') {
            conditionalValue = conditionalValue[key];
          } else {
            break;
          }
        }
        if (conditionalValue === field['conditionalShow']['value']) {
          showedFields.push(field);
        }
      }
    }
    return showedFields;
  }

  get showPageActions() {
    return this.selection && this.selection.length > 0 && this.formModel.status !== 'draft';
  }

  get showPageActionsLoading() {
    return this.selection && this.selection.length > 0 && this.isProcessing === true;
  }

  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  updateRowsActions() {
    this.updatePageActions();
    this.updateRowActions();
    this.getSelection();
  }

  extendUpdateRowActions(entity: any) {
    if (this.formModel.status === 'draft') {
      entity.actions.softDelete.show = true;
      entity.actions.softDelete.activated = true;
    } else {
      if (entity.status === 'rejected' || entity.status === 'sent') {
        entity.actions.confirm.show = true;
        entity.actions.confirm.activated = true;
      }
      if (entity.status === 'confirmed' || entity.status === 'sent') {
        entity.actions.reject.show = true;
        entity.actions.reject.activated = true;
      }
    }
  }

  public clickOnBulkMarkAsConfirmed() {
    const sessionCode = this.getSessionCode();
    this.listenToWebsocketdirectDebitFileItemsUpdatedChannel(sessionCode);
    const path = `${this.$bpcApiRouteHelper.getEntityPath('direct-debit-file-items')}/bulk-confirm`;
    this.$bpcApi
      .post(path, {
        directDebitFileItemIds: this.selection,
        session_code: sessionCode,
      })
      .subscribe();
  }

  public clickOnBulkMarkAsRejected() {
    this.showRejectDirectDebitFileItemModal = true;
    this.bulkReject = true;
    this.elementsToRejectIds = this.selection;
  }

  public clickOnMarkAsConfirmed(item: any) {
    const path = `${this.$bpcApiRouteHelper.getEntityPath('direct-debit-file-items')}/${
      item.item.id
    }/confirm`;
    this.$bpcApi.post(path).subscribe(
      res => {
        this.$refs.provider.getEntities();
      },
      error => {
        console.log('error');
      },
    );
  }

  public clickOnMarkAsRejected(item: any) {
    this.showRejectDirectDebitFileItemModal = true;
    this.bulkReject = false;
    this.elementToRejectId = item.item.id;
  }

  onCloseTicketToDirectDebitFileModal() {
    this.showRejectDirectDebitFileItemModal = false;
  }

  onDirectDebitFileItemsRejected() {
    this.showRejectDirectDebitFileItemModal = false;
    this.$refs.provider.getEntities();
  }

  listenToWebsocketdirectDebitFileItemsUpdatedChannel(sessionCode) {
    this.isProcessing = true;
    this.$bpcEcho
      .getDirectDebitFileItemsUpdatedChannel(sessionCode)
      .listen('.BPC\\Accounting\\Events\\DirectDebitFileItemsMarkedAsConfirmed', async data => {
        this.$bpcEcho.leaveDirectDebitFileItemsUpdatedChannel(sessionCode);
        this.isProcessing = false;
        this.$refs.provider.getEntities();
      })
      .listen('.BPC\\Accounting\\Events\\DirectDebitFileItemsMarkedAsRejected', async data => {
        this.$bpcEcho.leaveDirectDebitFileItemsUpdatedChannel(sessionCode);
        this.isProcessing = false;
        this.$refs.provider.getEntities();
      })
      .listen('.BPC\\Accounting\\Events\\GlobalErrorDirectDebitFileItemsUpdated', data => {
        this.$bpcMessage.showErrorMessage({
          text: data.msg,
        });
        this.$bpcEcho.leaveDirectDebitFileItemsUpdatedChannel(sessionCode);
        this.isProcessing = false;
        this.$refs.provider.getEntities();
      });
  }

  getSessionCode() {
    return `export-direct-debit-file-${this.tenantId}-${this.generateUUIDv4()}`;
  }

  generateUUIDv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  customOnRowAction($event: { event: string; item: any }) {
    switch ($event.event) {
      case 'mark-as-confirmed':
        this.clickOnMarkAsConfirmed($event.item);
        break;
      case 'mark-as-rejected':
        this.clickOnMarkAsRejected($event.item);
        break;
    }
  }

  onPageAction($event: string) {
    switch ($event) {
      case 'bulk-mark-as-confirmed':
        this.clickOnBulkMarkAsConfirmed();
        break;
      case 'bulk-mark-as-rejected':
        this.clickOnBulkMarkAsRejected();
        break;
    }
  }
}
